var _defs, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.98,33.36c1.61-7.88,8.58-13.8,16.94-13.8,9.55,0,17.29,7.74,17.29,17.29,0,.8-.05,1.58-.16,2.35,4.49,0,8.96,3.6,8.96,8.09s-3.64,8.13-8.13,8.13H20.21c-6.19,0-11.21-5.02-11.21-11.21s5.02-11.21,11.21-11.21c.96,0,1.89.12,2.77.35h0Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1.25 -5.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.98,
    y: 0
  }, "nline"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/__Online.dd1c4d62b5766d28ca1a1dfe9172daac.svg";
export { ForwardRef as ReactComponent };